/**
 * Recruiters 5010 — KUK "Where our graduates work".
 *
 * A heading, a supporting line, and a row of employer logos — two centred rows
 * below 768px, one wrapping row above it. Ported from kuk-campus-portal's
 * `components/organisms/AluminiCareers.tsx`; see `Recruiters5010.tsx` for why
 * neither Recruiters 1 nor Placements 1 fits.
 *
 * Every field maps to a column that already exists on `recruiters` — the variant
 * adds no schema of its own beyond widening `recruiters.variant`.
 */

export const RECRUITERS_5010_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Employer logos",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "",
    meta_title: "",
    meta_priority: 1,
    meta_status: true,
  },

  RECRUITERS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Where our graduates work",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#1F2937",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#1F2937",
      required: false,
      defaultValue: "#1F2937",
    },
    {
      fieldName: "sub_title",
      label: "Sub-heading",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Top companies trust us to deliver top talent.",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "sub_title_text_color",
      label: "Sub-heading colour",
      value: "#374151",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#374151",
      required: false,
      defaultValue: "#374151",
    },
    {
      fieldName: "background_color",
      label: "Band background",
      value: "#F5E4E7",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#F5E4E7",
      required: false,
      defaultValue: "#F5E4E7",
    },
    {
      fieldName: "desktop_bg_image",
      label: "Band background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — e.g. the reference's gradient exported as art",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_bg_image",
      label: "Band background image (mobile)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — falls back to the desktop image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Band background alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Logo",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload the employer logo",
      defaultValue: "",
    },
    {
      header: "Logo alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Employer name",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      description: "Used as the logo's alt text when no alt is set. Not shown on screen.",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
